angular.module('bmsApp.settings').factory('WorkflowTaskNoteSvc', function (CRUDSvc) {
	return {

		save: function(params) {
			return CRUDSvc.post('api/workflow/task/note/save', params);
		}
	}
});



